module.exports = __webpack_public_path__ + "img/24.983a0ef.png";